import script from "./DateRangeSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangeSetup.vue?vue&type=script&setup=true&lang=js"

import "./DateRangeSetup.vue?vue&type=style&index=0&id=16e6f804&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e6f804"]])

export default __exports__